export default __webpack_public_path__ + "static/media/rightIcon.f2df0dd1.svg";